const body = document.querySelector('.js-body');
const thisPage = body.dataset.page;
const { site } = body.dataset;
const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;

const vars = {
    body, thisPage, site, windowWidth, windowHeight
};

export { vars as default };
